import { render, staticRenderFns } from "./ProjectListView.vue?vue&type=template&id=9563ee68&scoped=true"
import script from "./ProjectListView.vue?vue&type=script&lang=ts"
export * from "./ProjectListView.vue?vue&type=script&lang=ts"
import style0 from "./ProjectListView.vue?vue&type=style&index=0&id=9563ee68&prod&scoped=true&lang=css"
import style1 from "./ProjectListView.vue?vue&type=style&index=1&id=9563ee68&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9563ee68",
  null
  
)

export default component.exports